import SiteNetworkHierarchy from "../../../generics/SiteNetworkHierarchy";
import AppHOC from "../../../generics/AppHOC";

// style
import css from "../insightsMagneticStyle.less";

// utils
import {
    isBandForecastingTabSelected,
    isAnomalyPage
} from "../../../utils/common";
import { useI18n } from "../../../i18n/useI18n";

const SubmenuHeaderView = (props) => {
    const { tViews } = useI18n('views');
    const localpath = window.location.pathname;
    const isOnboardingActive = localStorage.getItem("onboardingStatus") === "ACTIVE";   // Checking if onboarding status is active for predictive path recommendations

    let showSitesDropdown = true; // Default to show sites dropdown widget
    let title = "";

    if (localpath.includes("/threatintelligence")) {
        title = tViews('securityTabView.title');
        showSitesDropdown = false; // Hiding sites dropdown widget for threat intelligence page
    } else if (localpath.includes("/optimization")) {
        title = tViews('optimization.title');
    } else {
        title = tViews('predictiveNetworks.predictiveNetworksPageTitle');
        showSitesDropdown = isOnboardingActive && !isBandForecastingTabSelected() || isAnomalyPage(); // Condition to show sites dropdown widget
    }

    return (
        <div className={css["wani-header"]}>
            <div className="hbr-type-h1">{title}</div>
            {showSitesDropdown && <div className="sites-widget"><SiteNetworkHierarchy {...props} /></div>}
        </div>
    )
}
export default AppHOC(SubmenuHeaderView);